import { connect } from "react-redux";
import QuantityTypesCode from "../js/admin/QuantityTypesCode";
import { withRouter } from "react-router-dom";
import EntityPage from "../components/EntityPage";


class QuantityTypes extends EntityPage {

    constructor() {
        super('admin_local.menus.servings');
        this.code = new QuantityTypesCode()
    }

}
const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus && props.rootReducer.myStatus.restaurant_id) {
        return {
            restaurant: props.rootReducer.restaurant,
            myStatus: props.rootReducer.myStatus,
            admin_local: props.rootReducer.admin_local,
            local: props.rootReducer.local,
            speechRecognitionOn: props.rootReducer.speechRecognitionOn,
            ai: props.rootReducer.ai,
            speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable,
        };
    }
    return {};
};

export default connect(mapStateToProps)(withRouter(QuantityTypes));
